import React, { useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Navigation, Pagination, EffectFade } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import Modal from "./modal";

const Photogallery = ({ images }) => {
  const [initialSlide, setInitialSlide] = useState(-1);
  return (
    <>
      <div className="photogallery">
        {images.map((image, i) => (
          <button
            className="photogallery__item"
            key={image.contentful_id}
            onClick={() => setInitialSlide(i)}
          >
            <GatsbyImage
              alt=""
              image={getImage(image.gatsbyImageDataSmall)}
              className="photogallery__img"
            />
          </button>
        ))}
      </div>
      <Modal show={initialSlide >= 0} onHide={() => setInitialSlide(-1)}>
        <Swiper
          className="photogallery__slider"
          modules={[EffectFade, Pagination, Navigation]}
          pagination={{ clickable: true }}
          navigation
          spaceBetween={50}
          slidesPerView={1}
          initialSlide={initialSlide}
        >
          {images.map((image) => (
            <SwiperSlide key={image.contentful_id}>
              <div className="photogallery__item-full">
                <GatsbyImage
                  alt=""
                  image={getImage(image.gatsbyImageDataFull)}
                  className="photogallery__img-full"
                  objectFit="contain"
                />
                {/* <img src={image.file.url} className="photogallery__img-full" alt="" /> */}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Modal>
    </>
  );
};

export default Photogallery;
